export default function brandsMenu({main, on}) {
    main(() => {
        on('click', '[data-brands-toggle]', toggleGroup);
    });

    const toggleGroup = function (e) {
        const button = e.target.closest('[data-brands-toggle]');
        if (!button) return;

        const group = button.closest('.brands__group');
        const extraList = group?.querySelector('.brands__list--extra');
        if (!extraList) return;

        const isExpanded = !extraList.hidden;

        extraList.hidden = isExpanded;
        button.setAttribute('aria-expanded', String(!isExpanded));
        button.textContent = isExpanded ? button.dataset.showText : button.dataset.hideText;
    };
};

export const model = {};
